<ion-header>
  <ion-toolbar>
    <ion-title i18n="@@workShiftDialog.title"> Робоча зміна </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close" slot="icon-only"> </ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div>
    <table
      *ngIf="employeeSession"
      class="table table-borderless table-sm w-100"
    >
      <tr>
        <td i18n="@@workShiftDialog.employeeLabel">Працівник</td>
        <td>
          {{ employeeSession.employeename }}
        </td>
      </tr>
      <tr>
        <td i18n="@@workShiftDialog.startLabel">Початок</td>
        <td>
          {{ employeeSession.startdate | date : 'dd MMMM HH:mm' }}
        </td>
      </tr>
      <tr *ngIf="employeeSession.enddate">
        <td i18n="@@workShiftDialog.endLabel">Кінець</td>
        <td>
          {{ employeeSession.enddate | date : 'dd MMMM HH:mm' }}
        </td>
      </tr>
      <tr>
        <td i18n="@@workShiftDialog.ordersLabel">Чеків</td>
        <td>
          {{ employeeSession.orderscount }}
        </td>
      </tr>
      <tr>
        <td i18n="@@workShiftDialog.avgOrderLabel">Середній чек</td>
        <td>
          {{ employeeSession.averageorderamount }}
        </td>
      </tr>
      <tr>
        <td i18n="@@workShiftDialog.avgProductsLabel">Товарів в чеку</td>
        <td>
          {{ employeeSession.averageorderproducts }}
        </td>
      </tr>
    </table>
    <hr />
    <div *ngIf="!confirmClose" class="text-right">
      <button class="btn btn-sm btn-info" (click)="closeSession()" i18n="@@workShiftDialog.closeSessionBtn">
        Закрити зміну
      </button>
    </div>
    <div *ngIf="confirmClose" class="flex-container">
      <button class="btn btn-sm" (click)="cancelCloseSession()" i18n="@@workShiftDialog.cancelBtn">
        Відмінити
      </button>
      <span class="flex-spacer"></span>
      <button class="btn btn-sm btn-info" (click)="confirmCloseSession()" i18n="@@workShiftDialog.confirmCloseBtn">
        Підтвердіть закриття
      </button>
    </div>
  </div>
  <span class="bg-loader" *ngIf="loading"></span>
</ion-content>

<style>
  ::ng-deep .work-shifts-modal {
    padding-right: 10px;
    padding-bottom: 64px;
    --width: 310px;
    --height: 320px;
    align-items: end;
    justify-content: end;
  }
</style>
